import angular from 'angular';
import SelfRegistrationPiiComponent from 'registration/components/self-registration/pii/pii-component';
import SelfRegistrationComponent from './self-registration/self-registration-component';
import SelfRegistrationRetailerComponent from './retailer/retailer-component';
import SelfRegistrationConfirmComponent from './confirm-registration/confirm-registration-component';
import SelfRegistrationConfirmationComponent from './confirmation-registration/confirmation-registration-component';
import SelfRegistrationDisabledComponent from './registration-disabled/registration-disabled-component';
import SelfRegistrationPersonalInformationComponent from './personal-information/personal-information-component';

export default angular
  .module('self-registration', [])
  .component('selfRegistration', new SelfRegistrationComponent())
  .component('selfRegistrationRetailer', new SelfRegistrationRetailerComponent())
  .component('selfRegistrationPii', new SelfRegistrationPiiComponent())
  .component('selfRegistrationPersonalInformation', new SelfRegistrationPersonalInformationComponent())
  .component('selfRegistrationConfirm', new SelfRegistrationConfirmComponent())
  .component('selfRegistrationConfirmation', new SelfRegistrationConfirmationComponent())
  .component('selfRegistrationDisabled', new SelfRegistrationDisabledComponent());



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/self-registration-module.js